import { ClientPlaceholder } from './ClientPlaceholder';

/** `/me/account` — running balance and prepaid packages. */
export function MyAccount() {
  return (
    <ClientPlaceholder
      icon="user"
      titleKey="client.account.title"
      descriptionKey="client.account.description"
    />
  );
}
